import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';

import { ModulesStateModel } from './modules.state-model';

import { SetActiveModule, SetModules } from './modules.actions';

@State<ModulesStateModel>({
  name: 'modules',
  defaults: {
    modules: [],
    activeModule: null,
  },
})
@Injectable()
export class ModulesState {
  @Selector()
  static modules(state: ModulesStateModel): Array<any> {
    return state.modules;
  }

  @Selector()
  static activeModule(state: ModulesStateModel): any {
    return state.activeModule;
  }

  @Action(SetModules)
  public setModules(ctx: StateContext<ModulesStateModel>, { modules }: SetModules): void {
    ctx.patchState({ modules });
  }

  @Action(SetActiveModule)
  public setActiveModules(ctx: StateContext<ModulesStateModel>, { activeModule }: SetActiveModule): void {
    ctx.patchState({ activeModule });
  }
}
